// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"21d1abe9","349":"8e664824","495":"81877584","790":"5c25986f"}[chunkId] + ".css";
};